const getNestedValue = (object, key) => {
  if (typeof key === 'string') {
    return getNestedValue(object, key.split('.'));
  }
  const [nextPart, ...restOfParts] = key;
  if (restOfParts.length === 0) {
    return object[nextPart];
  }
  return getNestedValue(object[nextPart], restOfParts);
};

const searchObjects = (objects, keys, term) => {
  const searched = objects.filter((object) => {
    const values = keys.map((key) => getNestedValue(object, key));
    return values.some((value) => {
      if (typeof value !== 'string') {
        console.error('Only strings can be searched');
        return null;
      }
      return value.toLowerCase().includes(term.toLowerCase());
    });
  });

  return searched;
};

export { searchObjects };

const searcher = { searchObjects };
export default searcher;
